import { useEffect, useLayoutEffect, useState } from "react";
import { useRouter } from "next/router";

// SSR에서는 useLayoutEffect 대신 useEffect 사용 (서버에서 useLayoutEffect 경고 방지)
const useIsomorphicLayoutEffect = typeof window !== "undefined" ? useLayoutEffect : useEffect;

export function useIsFromPrime(): boolean {
  const router = useRouter();
  const [isFromPrime, setIsFromPrime] = useState(false);

  // useLayoutEffect: 페인트 전에 실행되어 prime 헤더 flash 방지
  useIsomorphicLayoutEffect(() => {
    if (router.query.from === "prime") {
      window.sessionStorage.setItem("from_prime", "true");
      setIsFromPrime(true);
    } else {
      setIsFromPrime(window.sessionStorage.getItem("from_prime") === "true");
    }
  }, [router.query.from]);

  return isFromPrime;
}
